import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function EpidemicStatus({ nextStep, prevStep }) {
  return (
    <>
      <div className="form-navigator-body">
        <div className="row">
          <div className="col-lg-6">
            <div className="form-group">
              <label>95-95-99 Status of District</label>
              <div className="row">
                <div className="col-lg-4">
                  <input
                    type="text"
                    placeholder=""
                    //  value="81"
                  />
                </div>
                <div className="col-lg-4">
                  <input
                    type="text"
                    placeholder=""
                    //  value="87"
                  />
                </div>
                <div className="col-lg-4">
                  <input
                    type="text"
                    placeholder=""
                    //  value="92"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <label>Category (High/Moderate/Low/Very Low)</label>
              <div class="custom-select">
                <select class="form-control" id="stateSelect" name="state">
                  <option value="" selected="">
                    Select Category
                  </option>
                  <option value="High">High</option>
                  <option value="Moderate">Moderate</option>
                  <option value="Low">Low</option>
                  <option value="Very Low">Very Low</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="form-group">
              <label>
                EVTHS Burden as per HIV Sentinel Surveillance (no. of positive
                pregnant women)
              </label>
              <input
                type="text"
                placeholder=""
                // value="53"
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="form-group">
              <label>Year of HIV Sentinel Surveillance </label>
              <div class="custom-select">
                <select class="form-control" id="stateSelect" name="state">
                  <option value="" selected="">
                    Select Year
                  </option>
                  <option value="2019">2019</option>
                  <option value="2020">2020</option>
                  <option value="2021">2021</option>
                  <option value="2022">2022</option>
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="referenceText">
          ** Reference can be taken from latest SANKALAK or latest India HIV
          Estimates
        </div>
      </div>

      <div className="form-navigate-footer">
        {/* <button onClick={() => alert("Form Submitted!")} className="bg-green-500  px-4 py-2 rounded">Submit</button> */}
        <button onClick={prevStep} className="btn btn-outline-secondary">
          Back
        </button>
        <button onClick={nextStep} className="btn btn-dark border-0">
          Next
        </button>
      </div>
    </>
  );
}
